import React from 'react';

import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import messages from './GuaranteedMinimumPanel.messages';
import './GuaranteedMinimumPayoutBar.scss';

const { block, element } = bem('guaranteed-minimum-payout-bar');

const payoutBarRichTextValues = {
  br: () => <br />,
};

const GuaranteedMinimumPayoutBar = () => (
  <div aria-hidden className={block()}>
    <div className={element('labels')}>
      <Message as="span" className={element('payout-label')} message={messages.payoutBarPayout} />
    </div>
    <div className={element('track-wrap')}>
      <div className={element('track')}>
        <div className={element('fill')} />
      </div>
      <span className={element('tick', { 'position-rate-floor': true })} />
      <span className={element('tick', { 'position-direct-price': true })} />
    </div>
    <div className={element('axis-labels')}>
      <Message
        as="span"
        className={element('axis-label', { 'position-rate-floor': true })}
        message={messages.payoutBarRateFloor}
        values={payoutBarRichTextValues}
      />
      <Message
        as="span"
        className={element('axis-label', { 'position-direct-price': true })}
        message={messages.payoutBarDirectPrice}
        values={payoutBarRichTextValues}
      />
    </div>
  </div>
);

export default GuaranteedMinimumPayoutBar;
